import type { PaletteMode } from "@mui/material/styles";
import {
  DEFAULT_BRAND_COLOR,
  SEEDIT_DARK_SURFACES,
  SEEDIT_LIGHT_SURFACES
} from "./seedit-theme.tokens";

/** Compile-time fallback when CSS vars are not yet synced (e.g. first paint). */
export const MOBISCROLL_ACCENT_FALLBACK = DEFAULT_BRAND_COLOR;

export const MOBISCROLL_RADIUS_PX = 8;
export const MOBISCROLL_RADIUS_LG_PX = 12;

export type MobiscrollThemeSurfaces = {
  surface: string;
  elevated: string;
  border: string;
  text: string;
  textSecondary: string;
};

export const MOBISCROLL_THEME_SURFACES: Record<PaletteMode, MobiscrollThemeSurfaces> = {
  light: {
    surface: SEEDIT_LIGHT_SURFACES.background.paper,
    elevated: SEEDIT_LIGHT_SURFACES.background.paper,
    border: "#E2E8F0",
    text: SEEDIT_LIGHT_SURFACES.text.primary,
    textSecondary: SEEDIT_LIGHT_SURFACES.text.secondary
  },
  dark: {
    surface: SEEDIT_DARK_SURFACES.background.paper,
    elevated: "#252633",
    border: "#334155",
    text: SEEDIT_DARK_SURFACES.text.primary,
    textSecondary: SEEDIT_DARK_SURFACES.text.secondary
  }
};
